import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import {
  getSubmitStatus,
  getAllQuickPlans,
  getQuickSubUpcomingPlan,
  getLoggedInUser,
} from 'reducers';
import {
  setUpcomingQuickPlan as setUpcomingPlan,
  lockQuickPlan,
} from 'actions/quickSubs';
import { fetchAllPlans } from 'actions/quickPlans';
import SplitedPlanForm from 'components/SplitedPlanForm';
import PlanForm from 'components/PlanForm';
import QuickSubNav from 'components/SubNav/quick';
import SetUpcomingPlanModal from './SetUpcomingPlanModal';

const isSuitableForSplittedForm = (user) =>
  !['BUSINESS', 'RESELLER', 'RESOLD_USER'].includes(user.acl_group_name);

const mapStateToProps = (state, { subId, user }) => {
  const selector = formValueSelector('plan');
  const loggedInUser = getLoggedInUser(state);
  const showSplittedForm =
    user &&
    loggedInUser &&
    isSuitableForSplittedForm(user) &&
    isSuitableForSplittedForm(loggedInUser);

  return {
    saveStatus: getSubmitStatus(state, 'plan'),
    planName: selector(state, 'plan_name'),
    plans: getAllQuickPlans(state),
    upcomingPlan: getQuickSubUpcomingPlan(state, subId),
    SubNav: QuickSubNav,
    heading: 'Set Quick Upcoming Plan',
    upgradePlanLink: (subId) => `/quick/subscriptions/${subId}/upgrade-invoice`,
    loggedInUser,
    PlanForm:
      user && loggedInUser
        ? showSplittedForm
          ? SplitedPlanForm
          : PlanForm
        : null,
    isQuick: true,
    showSplittedForm,
  };
};

const mapDispatchToProps = {
  setUpcomingPlan,
  fetchAllPlans,
  lockPlan: lockQuickPlan,
  changeField: change,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetUpcomingPlanModal);
